module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "is-fullhd"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-8"
  }, [_c('vue-good-table', {
    staticClass: "table table-responsive",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "lineNumbers": true,
      "fixed-header": false,
      "search-options": {
        enabled: false,
      },
      "paginationOptions": {
        enabled: true,
        mode: 'pages',
        perPageDropdown: [5, 8, 10, 15, 25]
      },
      "rowStyleClass": _vm.rowStyleClassFn,
      "styleClass": "vgt-table table table-bordered table-striped comments_table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'action') ? _c('span', [_c('v-btn', {
          attrs: {
            "ripple": false
          },
          on: {
            "click": function($event) {
              _vm.loadComment(props.row, $event)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "blue"
          }
        }, [_vm._v("visibility")])], 1)], 1) : _c('span', {
          staticStyle: {
            "font-family": "Roboto",
            "font-size": "18px"
          }
        }, [_vm._v("\n              " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }, {
      key: "table-column",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "font-family": "Roboto",
            "font-size": "20px",
            "color": "#1E70EC"
          }
        }, [_vm._v("\n                " + _vm._s(props.column.label) + "\n            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('span', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.png"
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-12"
  })]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('form', {
    staticStyle: {
      "font-family": "Roboto"
    },
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head bg-primary"
  }, [_c('span', {
    staticClass: "modal-card-title",
    staticStyle: {
      "color": "white"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userComment.fullName))])])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('blockquote', [_vm._v("\n                    " + _vm._s(_vm.userComment.comment) + "\n                    "), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.userComment.organization))])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot pull-right"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = false
      }
    }
  }, [_vm._v("CLOSE")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType === 'superadmin'),
      expression: "userType === 'superadmin'"
    }]
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.sureDelete = !_vm.sureDelete
      }
    }
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sureDelete),
      expression: "sureDelete"
    }],
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.removeComment(_vm.userComment.timestamp)
      }
    }
  }, [_vm._v("Click to confirm DELETE")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType === 'admin'),
      expression: "userType === 'admin'"
    }]
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('You dont have the permission to delete a comment'),
      expression: "'You dont have the permission to delete a comment'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "button is-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("DELETE")])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "margin": "10px 10px"
    }
  }, [_c('span', {
    staticClass: "column is-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "column is-8"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-family": "'Open Sans', Roboto, sans-serif",
      "font-size": "16px",
      "color": "blue"
    }
  }, [_vm._v("\n              These are comments made by the users of the dashboard from different locations world over.\n              Comments are saved on the user browser, and syncs with the to the cloud when there's internet\n              Note that only superadmin users can delete unuseful comments.\n            ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d83114c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/feedback.vue
// module id = 978
// module chunks = 3